import { createRoot, Root } from 'react-dom/client'
import { flushSync } from 'react-dom'
import { ReactNode } from 'react'

const roots=new WeakMap<Element,Root>()

// Imperative callers expect mounted content before returning, and synchronous
// cleanup before discarding a popup or changing the active account.
export function render(children:ReactNode,container:Element) {
    let root=roots.get(container)
    if(!root){root=createRoot(container);roots.set(container,root)}
    flushSync(()=>root.render(children))
}
export function unmount(container:Element) {
    const root=roots.get(container)
    if(!root)return false
    roots.delete(container)
    flushSync(()=>root.unmount())
    return true
}
